import { createStateLoader } from 'Common/components/app';
import { customer } from '~features';

export default createStateLoader({
    setState: customer.actions.setCustomerOrders,
    clearState: customer.actions.clearCustomerOrders,
});
